import React from 'react';
import { format } from 'date-fns';

export const DateCell = (value: any) => <React.Fragment>{format(new Date(value), 'dd.MM.yyyy, HH:mm')}</React.Fragment>;
